import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { DiscoverMoreStyled } from "./styled";
import { Icons } from "components";

const DiscoverMore = ({ theme_standard, onClick }) => {
  const { t } = useTranslation(["common"]);
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <DiscoverMoreStyled className={customClass} onClick={onClick}>
      <div className="text">{t("Discover more about activity", { ns: "common" })}</div>
      <Icons.ArrowRightCircle2 color="#4B247E" width={28} height={28}/>
    </DiscoverMoreStyled>
  );
};

DiscoverMore.propTypes = {};

export default DiscoverMore;
